import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UserStateService } from 'src/app/auth/services/user-state.service';
import { CompanyIcpService } from 'src/app/components/company-icp/company-icp.service';
import { RvshareAppDetectionService } from 'src/app/screen-sharing/services/rvshare-app-detection.service';
import { environment } from 'src/environments/environment';
import { CookieTesterService } from '../../services/cookie-tester.service';

@Component({
  selector: 'common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss'],
  standalone: false,
})
export class CommonHeaderComponent implements OnInit {
  @Input() hideNavigation: boolean = true;
  @Input() currentRoute: string = '';

  ENV_NAME = environment.ENV_NAME;
  cookieEnabled = true;

  @Output() openMobileMenu = new EventEmitter<void>();
  @Output() toggleNavigation = new EventEmitter<void>();

  get isScreenShareApp(): any {
    return this.rvShareAppDetection.isScreenShareApp();
  }

  get isAssignedPublisher(): any {
    return this.userStateService.isAssignedPublisher();
  }

  get isTemplateEditor(): boolean {
    return this.currentRoute === 'apps.editor.templates.edit';
  }

  constructor(
    public userStateService: UserStateService,
    private companyIcpService: CompanyIcpService,
    private rvShareAppDetection: RvshareAppDetectionService,
    private cookieTesterService: CookieTesterService,
  ) {}

  ngOnInit(): void {
    this.companyIcpService.init();

    if (!this.cookieTesterService.checkCookies()) {
      this.cookieEnabled = false;
    }
  }

  onMenuButtonClick(): void {
    if (this.isTemplateEditor) {
      this.toggleNavigation.emit();
    } else {
      this.openMobileMenu.emit();
    }
  }
}
